import { useEffect, useRef } from "react";
import { sendEvent } from "@/lib/googleSheet";
import { getOrCreateUserId } from "@/lib/session";

interface TrackSectionProps {
  id: string;      // unique section name
  children: React.ReactNode;
  minHeight?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const TrackSection = ({ id, children, minHeight = "100vh", className = "" ,style}: TrackSectionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const userId = getOrCreateUserId();
  let timer: NodeJS.Timeout | null = null;
  let startTime: number | null = null;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startTime = Date.now();
            timer = setTimeout(() => {
              const duration = (Date.now() - Number(startTime)) / 1000;
              sendEvent(userId, `SECTION_VIEW_${id}`, duration);
            }, 5000); // must stay for 5 seconds
          } else {
            if (timer) clearTimeout(timer);
          }
        });
      },
      { threshold: 0.7 } // section must be mostly visible
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ minHeight: minHeight ,...style }} className={className}>
      {children}
    </div>
  );
};
